import { render, staticRenderFns } from "./TaglineEditor.vue?vue&type=template&id=69c429a7&scoped=true"
import script from "./TaglineEditor.vue?vue&type=script&lang=ts"
export * from "./TaglineEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c429a7",
  null
  
)

export default component.exports